<div class="bg-white">
  <div class="flex justify-center items-end flex-wrap py-4">
    <a
      [href]="item.url"
      *ngFor="let item of frontSettings.ASSOCIATED_BRAND_LOGOS"
      target="_blank"
      class="mx-4"
    >
      <img
        class="pb-3 block md:hidden"
        [alt]="item.name"
        [src]="item.urlImage"
        [ngStyle]="convertStylesToJson(item.styles!, 'responsive')"
      />

      <img
        class="pb-3 hidden md:block"
        [alt]="item.name"
        [src]="item.urlImage"
        [ngStyle]="convertStylesToJson(item.styles!, 'base')"
      />
    </a>
  </div>

  <div
    class="grid md:flex space-x-0 md:space-x-8 m-auto grid-cols-2 md:grid-cols-8 justify-center text-xs text-center mb-6 md:mx-10 lg:mx-0 text-[#415564]"
  >
    <a
      class="cursor-pointer pb-2"
      aria-label="Glosario"
      [routerLink]="['/help-center', 'HELP_CENTER_ORDER_STATUS']"
      >Glosario</a
    >
    <a
      class="cursor-pointer pb-2"
      [ariaLabel]="frontSettings.URL_FOOTER_IOMABE?.name"
      [href]="frontSettings.URL_FOOTER_IOMABE?.url"
      target="_blank"
      >Conoce IO Mabe</a
    >
    <a
      class="cursor-pointer pb-2"
      [ariaLabel]="frontSettings.URL_FOOTER_MABEINTERNATIONAL?.name"
      [href]="frontSettings.URL_FOOTER_MABEINTERNATIONAL?.url"
      target="_blank"
      >Mabe Internacional</a
    >
    <a
      class="cursor-pointer pb-2"
      [ariaLabel]="frontSettings.URL_FOOTER_CORPORATE?.name"
      [href]="frontSettings.URL_FOOTER_CORPORATE?.url"
      target="_blank"
      >Corporativo</a
    >
    <a
      class="cursor-pointer pb-2"
      [ariaLabel]="frontSettings.URL_FOOTER_WORKMABE?.name"
      [href]="frontSettings.URL_FOOTER_WORKMABE?.url"
      target="_blank"
      >Trabaja en Mabe</a
    >
    <a
      class="cursor-pointer pb-2"
      aria-label="Aviso de privacidad"
      onclick="privacy_notice.showModal()"
      >Aviso de privacidad</a
    >
    <a
      class="cursor-pointer pb-2"
      aria-label="Terminos y condiciones"
      onclick="terms.showModal()"
      >Términos y condiciones</a
    >
    <a
      class="cursor-pointer pb-2"
      aria-label="Centro de ayuda"
      [routerLink]="['/help-center']"
      >Centro de ayuda</a
    >
  </div>

  <div
    class="w-full bg-primary text-white py-4 text-center text-[8px] md:text-xs px-4"
  >
    <span
      >©{{ currentYear }} TODOS LOS DERECHOS RESERVADOS MABE MÉXICO AVENIDA DE LAS PALMAS
      215, INTERIOR: PISO 7, LOMAS DE CHAPULTEPEC, I SECCIÓN, MIGUEL HIDALGO,
      CIUDAD DE MÉXICO, CP 11000</span
    >
  </div>
</div>

<!-- Modal -->
<dialog id="privacy_notice" class="modal w-full p-0 bg-black bg-opacity-50">
  <div class="fixed inset-0 bg-black bg-opacity-50"></div>

  <div id="modalBox" class="modal-box p-10 bg-white relative z-10 rounded-xl">
    <form method="dialog">
      <button
        class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 text-secondary font-bold text-2xl"
      >
        ✕
      </button>
    </form>
    <h3 class="text-lg font-bold text-primary">AVISO DE PRIVACIDAD</h3>
    <h4 class="text-gray-400">(MÉXICO)</h4>
    <div id="avisoPrivacidad" class="text-[#1E3746]">
      <br />
      <h3 class="font-bold text-base">
        Información general del Aviso de Privacidad
      </h3>
      <p>
        Para Controladora Mabe, S.A, de C.V, (en adelante MABE), sus empresas
        subsidiarias y filiales el debido tratamiento y protección de sus datos
        personales es de la máxima importancia. Mediante este Aviso de
        Privacidad nos comprometemos con usted a utilizar sus datos personales
        exclusivamente para los fines aquí informados y hacer los mejores
        esfuerzos para protegerlos contra cualquier uso no autorizado.
      </p>
      <p>
        De igual manera, a través del presente Aviso de Privacidad le informamos
        sobre la existencia y forma en la que puede hacer efectivos sus derechos
        de protección de datos personales previstos en las leyes aplicables a
        fin de que usted tenga pleno control y disposición sobre sus datos
        personales.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Identidad y domicilio del Responsable del tratamiento
      </h3>
      <p>
        En México la entidad responsable del tratamiento de sus datos personales
        será “Controladora Mabe, S.A. de C.V.” con domicilio en Av. de las
        Palmas 100, Colonia Lomas de Chapultepec, C.P. 11000, Alcaldía Miguel
        Hidalgo, Ciudad de México, México.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Datos del Oficial de Protección de Datos de Mabe:
      </h3>
      <p>
        Para cualquier duda relacionada con la privacidad y protección de sus
        datos personales podrá contactar al Oficial de Protección de Datos de
        Mabe a la dirección de correo electrónico
        <a href="mailto:datos.personales&#64;mabe.com.mx"
          >datos.personales&#64;mabe.com.mx</a
        >
      </p>
      <br />
      <h3 class="font-bold text-base">
        Categorías de datos personales sujetos al tratamiento:
      </h3>
      <p>
        Para cumplir con las finalidades del tratamiento señaladas en el
        presente Aviso de Privacidad, Mabe recabará y dará tratamiento a los
        siguientes datos personales:
      </p>
      <ol type="a" class="list-[lower-alpha] ms-5">
        <li>Datos de identificación;</li>
        <li>Datos de contacto;</li>
        <li>Datos de ubicación;</li>
        <li>Datos demográficos;</li>
        <li>Datos patrimoniales y/o financieros;</li>
        <li>Datos fiscales;</li>
        <li>
          Información que usted nos proporcione de manera voluntaria para la
          atención de quejas, reclamaciones o seguimiento a las mismas.
        </li>
      </ol>
      <p>
        Además, le informamos que Mabe podrá dar tratamiento a datos de
        identificación y contacto de terceros en caso de que usted proporcione
        dicha información para fines relacionados con la entrega de productos,
        seguimiento de pedidos y/o como referencia personal. Al proporcionar
        dicha información a Mabe usted reconoce que cuenta con el consentimiento
        respectivo del Titular, a fin de que Mabe pueda tratar dichos datos para
        el cumplimiento de las finalidades referidas.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Tratamiento de datos personales sensibles:
      </h3>
      <p>
        Le informamos que para cumplir con las finalidades informadas en el
        presente Aviso de Privacidad Mabe no tratará datos personales sensibles.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Consecuencias de la negativa a proporcionar sus datos personales:
      </h3>
      <p>
        El principal fin para el cual Mabe trata sus datos personales es para
        cumplir con las obligaciones derivadas de la relación comercial y/o
        jurídica con usted y brindarle los servicios que solicite. Por ende, la
        negativa de su parte para proporcionarnos sus datos personales impedirá
        la posible relación comercial y/o jurídica así como brindarle los
        servicios que usted requiera.
      </p>
      <br />
      <h3 class="font-bold text-base">Calidad de la información:</h3>
      <p>
        Le informamos que usted está obligado a proporcionar datos personales
        que sean veraces, correctos y actualizados, por lo que, cuando usted nos
        proporciona dicha información de forma directa asumiremos que esta
        cumple con los requisitos anteriores. En caso de que Mabe cuente con
        elementos objetivos que demuestren que la información proporcionada es
        inexacta o incorrecta se procederá a la actualización, rectificación,
        y/o eliminación de la misma.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Finalidades primarias del tratamiento:
      </h3>
      <p>
        Mabe tratará sus datos personales para cumplir con las siguientes
        finalidades primarias:
      </p>
      <ol type="a" class="list-[lower-alpha] ms-5">
        <li>Para identificarle como cliente y acreditar su identidad;</li>
        <li>
          Contactarle a través de diversos medios electrónicos con el fin de
          realizar las gestiones necesarias para dar trámite a su solicitud y en
          su caso, realizar la entrega de las mercancías y/o productos
          solicitados en el domicilio que usted indique para ello;
        </li>
        <li>
          Creación de su cuenta de usuario en nuestro sitio web y expedirle
          credenciales de acceso al mismo;
        </li>
        <li>
          Permitirle acceso a las funciones y servicios de nuestro sitio web;
        </li>
        <li>
          Determinar la zona geográfica donde usted se encuentre para ofrecerle
          contenidos, promociones o beneficios correspondientes a esa zona;
        </li>
        <li>
          Realizar un registro de sus actividades y operaciones en nuestro sitio
          web;
        </li>
        <li>Detectar y prevenir fraudes;</li>
        <li>
          Procesar pagos a través de distintos mecanismos de pago admitidos;
        </li>
        <li>Realizar gestiones de facturación y cobranza;</li>
        <li>Valorar su experiencia de compra y/o servicio con nosotros;</li>
        <li>Realizar reportes de carácter interno;</li>
        <li>
          Informarle sobre cambios o nuevos productos o servicios que estén
          relacionados con los productos adquiridos por usted;
        </li>
        <li>
          Realizar actividades de monitoreo de calidad en los servicios o sobre
          su experiencia de compra con nosotros;
        </li>
        <li>
          Mantener la seguridad de las redes y servicios de comunicaciones
          electrónicas, detectar fallos o errores técnicos en la transmisión de
          las comunicaciones electrónicas, así como cualquier tratamiento que
          sea necesario para la correcta prestación de los servicios;
        </li>
        <li>
          Dar cumplimiento a políticas y procedimientos de carácter interno;
        </li>
        <li>
          Dar atención a sus solicitudes de información, aclaraciones, quejas o
          reclamaciones;
        </li>
        <li>
          Dar cumplimiento a las obligaciones derivadas de la relación comercial
          y/o jurídica con usted;
        </li>
        <li>
          Dar cumplimiento a los requerimientos de autoridades competentes en
          los casos legalmente previstos.
        </li>
        <li>
          Hacer análisis de datos con fines de hacer análisis de datos con fines
          comerciales, operativos, de mejora de productos, servicios y
          experiencia del cliente.
        </li>
      </ol>
      <br />
      <h3 class="font-bold text-base">
        Finalidades secundarias del tratamiento:
      </h3>
      <p>
        De manera adicional, en caso de contar con su consentimiento, Mabe podrá
        tratar su información personal para las siguientes finalidades que no
        son indispensables para el servicio que nos solicite, pero, que nos
        permiten y facilitan brindarle una mejor atención:
      </p>
      <ol type="a" class="list-[lower-alpha] ms-5">
        <li>
          Para posibles contactos posteriores con motivo de la relación
          comercial y/o juridica (Finalidad secundaria A).
        </li>
        <li>
          Informarle del lanzamiento o cambios de nuevos productos, bienes,
          servicios, promociones y/u ofertas de acuerdo con sus intereses,
          incluyendo el envío de comunicaciones a través de correos
          electrónicos, llamadas telefónicas, mensajes cortos y demás medios de
          comunicación físicos y/o electrónicos (Finalidad secundaria B);
        </li>
        <li>
          Para enviarle publicidad y comunicaciones con fines de mercadotecnia
          (Finalidad secundaria C).
        </li>
      </ol>
      <br />
      <h3 class="font-bold text-base">
        Base(s) de legitimación para el tratamiento de sus datos personales:
      </h3>
      <p>
        Mabe da tratamiento a sus datos personales con el fin de dar
        cumplimiento a las obligaciones derivadas de la relación comercial y/o
        jurídica con usted respecto a aquellas finalidades consideradas como
        primarias o necesarias, mismas que no se encuentran sujetas a su
        consentimiento expreso en virtud de que la base de legitimación para el
        tratamiento es la relación jurídica entre las partes, por ello, se
        entenderá que usted otorga su consentimiento al momento de establecer
        y/o continuar su relación comercial y/o jurídica con Mabe.
      </p>
      <p>
        Mabe dará tratamiento a sus datos personales para las finalidades
        informadas como secundarias previo su consentimiento específico, libre e
        informado.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Períodos de conservación de sus datos personales:
      </h3>
      <p>
        Mabe conservará sus datos personales durante el tiempo que sea necesario
        para el cumplimiento de los fines establecidos en este Aviso de
        Privacidad de acuerdo con las leyes aplicables y en tanto se mantenga la
        relación comercial y/o jurídica con usted. Una vez cumplida la finalidad
        de su tratamiento, sus datos personales serán cancelados. Para
        determinar el período de retención apropiado para los datos,
        consideramos la normatividad vigente y naturaleza de los datos
        personales.
      </p>
      <br />
      <h3 class="font-bold text-base">Transferencias:</h3>
      <p>
        Desde este acto se le informa que, Mabe podrá transferir sus datos
        personales, tanto a entidades nacionales como extranjeras en los
        siguientes casos:
      </p>
      <ol type="a" class="list-[lower-alpha] ms-5">
        <li>
          Empresas afiliadas, subsidiarias y/o entidades bajo control común de
          Mabe Global que operan bajo las mismas políticas internas en materia
          de protección de datos personales para dar cumplimiento a las
          finalidades informadas en este Aviso de Privacidad y para que éstas le
          puedan contactar directa o indirectamente, para llevar a cabo
          actividades de segmentación, perfilamiento, promoción y en su caso,
          ofrecimiento de productos y/o servicios que dichas empresas pueden
          comercializar y/o prestar de manera conjunta con Mabe o de manera
          independiente.
        </li>
        <li>
          Autoridades competentes en los casos previstos por la normatividad
          aplicable.
        </li>
        <li>
          A aquellos terceros con los que Mabe mantiene una relación civil y/o
          de prestación de servicios y que deban tener conocimiento de sus datos
          personales con la única finalidad de realizar las actividades
          necesarias que resulten con motivo de la relación comercial y/o
          jurídica, tales como: entrega de productos, atención de servicios
          postventa, entre otras afines.
        </li>
      </ol>
      <p>
        Además, si usted otorga su consentimiento, Mabe podrá transferir los
        datos personales necesarios a socios comerciales y/o terceros con los
        que tengamos celebrados acuerdos jurídicos vinculantes para que estos
        puedan contactarle y ofrecerle bienes, productos y servicios que
        resulten de su interés, o bien, para que puedan determinar si usted es
        sujeto a adquirir los bienes y/o servicios que dichos terceros ofrecen.
      </p>
      <p>
        Si usted no desea que Mabe lleve a cabo la transferencia de referencia,
        por favor envíe un correo electrónico a
        <a href="mailto:datos.personales&#64;mabe.com.mx"
          >datos.personales&#64;mabe.com.mx</a
        >
        Usted podrá cambiar de opción en cualquier momento.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Información y medios sobre el ejercicio de sus derechos ARCO:
      </h3>
      <p>
        Usted o su representante legal podrá ejercer cualquiera de los derechos
        de acceso, rectificación, cancelación u oposición (en lo sucesivo
        “Derechos ARCO”), así como revocar su consentimiento para el tratamiento
        de sus datos personales enviando un correo electrónico a nuestro Oficial
        de Protección de Datos a la dirección
        <a href="mailto:datos.personales&#64;mabe.com.mx"
          >datos.personales&#64;mabe.com.mx</a
        >
        donde esta, se atenderá en tiempo y forma. Para que su solicitud sea
        atendida debidamente es necesario que nos envíe un escrito indicando de
        forma específica el y/o los derechos que pretende ejercer ante Mabe y
        acompañarse con copia de alguna identificación oficial vigente
        proporcionando además un medio de contacto.
      </p>
      <p></p>
      <p>
        En caso de que usted presente una solicitud para ejercicio de los
        derechos anteriores y la información proporcionada sea errónea o
        insuficiente, o bien, no se acompañen los documentos de acreditación
        correspondientes, el Oficial de Protección de Datos de Mabe, dentro de
        los cinco (5) días hábiles siguientes a la recepción de la solicitud,
        podrá requerirle que aporte los elementos o documentos necesarios para
        dar trámite a la misma. Usted contará con diez (10) días hábiles para
        atender el requerimiento, contados a partir del día siguiente en que lo
        haya recibido. De no dar respuesta en dicho plazo, se tendrá por no
        presentada la solicitud correspondiente.
      </p>
      <p>
        El Oficial de Protección de Datos de Mabe le comunicará la determinación
        adoptada, en un plazo máximo de veinte (20) días hábiles contados desde
        la fecha en que se recibió la solicitud, a efecto de que, si resulta
        procedente, haga efectiva la misma dentro de los quince (15) días
        hábiles siguientes a que se comunique la respuesta. La respuesta se dará
        vía electrónica a la dirección de correo que usted haya indicado.
      </p>
      <p>
        En caso de considerarlo necesario, le informamos que tiene el derecho de
        acudir ante el Instituto Nacional de Transparencia Acceso a la
        Información y Protección de Datos Personales (INAI) para hacer valer
        cualquier inconformidad relacionada con su derecho a la protección de
        datos personales.
      </p>
      <br />
      <h3 class="font-bold text-base">Uso de tecnologías de rastreo:</h3>
      <p>
        Mabe utiliza varias tecnologías para mejorar la eficiencia y experiencia
        de navegación en sus sitios web. Entre estas tecnologías se incluye el
        uso de cookies, que son pequeñas cantidades de información que se
        almacenan en el navegador utilizado por cada usuario para que el
        servidor recuerde cierta información que posteriormente pueda utilizar.
      </p>
      <p>
        Utilizamos los siguientes tipos de cookies para las finalidades que se
        indican a continuación:
      </p>
      <ol type="a" class="list-[lower-alpha] ms-5">
        <li>
          <strong>Cookies esenciales o técnicas:</strong> Utilizamos estas
          tecnologías para permitirle un uso adecuado y operación de nuestro
          sitio web.
        </li>
        <li>
          <strong>Cookies para recordar sus preferencias y experiencia:</strong>
          A través de estas tecnologías obtenemos horario de navegación, tiempo
          de navegación en nuestra página de Internet, secciones consultadas, y
          páginas de Internet accedidas previo a la nuestra, estas cookies nos
          permiten recordar sus preferencias, opciones de navegación y funciones
          personalizadas en nuestro sitio web.
        </li>
        <li>
          <strong>Cookies para objetivos de rendimiento y análisis:</strong>
          Podemos usar cookies propias y de terceros para obtener datos de
          carácter técnico y estadístico que nos permitan identificar la forma
          en la cual usted hace uso de nuestros servicios con la finalidad de
          mejorar su rendimiento y futuros desarrollos.
        </li>
        <li>
          <strong>Cookies de funcionalidad:</strong> Mediante estas cookies
          podemos proporcionarle una experiencia de navegación personalizada
          cada vez que visite nuestro sitio web. Estas cookies nos permiten
          guardar su carrito de compras, recordar sus preferencias de compra,
          crear una lista de deseos y agilizar su proceso de compra cuando
          visita nuestro sitio web.
        </li>
        <li>
          <strong>Cookies publicitarias y de redes sociales:</strong> Estas
          cookies nos permiten recordar sus preferencias de productos, compras y
          servicios en las iniciativas de marketing. Mediante estas cookies
          podemos conocer y compartir datos e información sobre sus gustos,
          preferencias, hábitos de consumo e interacciones para personalizar
          anuncios, desarrollar un perfil específico para mostrar publicidad en
          función del mismo y llevar a cabo actividades de segmentación de
          audiencias y permitir interacciones en nuestro sitio web.
        </li>
      </ol>
      <p>
        Algunas de las cookies que utilizamos en nuestro sitio web son
        necesarias para permitir su funcionamiento y no se pueden desactivar de
        nuestros sistemas. No obstante, usted puede deshabilitar aquellas
        cookies no esenciales, siguiendo el aplicable de acuerdo con el tipo de
        navegador que utilice para acceder a nuestro sitio web:
      </p>
      <ol type="i" class="list-[lower-roman] ms-5">
        <li>
          Internet Explorer: Herramientas -&gt; Opciones de Internet -&gt;
          Privacidad -&gt; Configuración. Para más información, puede consultar
          el siguiente
          <a
            href="http://windows.microsoft.com/es-es/internet-explorer/delete-manage-cookies"
            >enlace.</a
          >
        </li>
        <li>
          Firefox: Herramientas -&gt; Opciones -&gt; Privacidad y Seguridad.
          Para más información, puede consultar el siguiente
          <a
            href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias"
            >enlace.</a
          >
        </li>
        <li>
          Chrome: Configuración -&gt; Verificación de seguridad y/o -&gt;
          Privacidad y seguridad. Para más información, puede consultar el
          siguiente
          <a href="https://support.google.com/chrome/answer/95647?hl=es"
            >enlace.</a
          >
        </li>
        <li>
          Safari: Preferencias -&gt; Seguridad. Para más información, puede
          consultar el siguiente
          <a href="https://support.apple.com/kb/PH19214?&amp;viewlocale=es_ES"
            >enlace.</a
          >
        </li>
        <li>
          Opera: Configuración -&gt; Privacidad, búsqueda y servicios y/o
          Permisos del sitio. Para más información, puede consultar el siguiente
          <a href="http://www.opera.com/help/tutorials/security/cookies/"
            >enlace.</a
          >
        </li>
      </ol>
      <p>
        A través de su navegador de internet, usted también puede ver las
        cookies que están en su dispositivo, y borrarlas según crea conveniente.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Autoridad de protección de datos personales:
      </h3>
      <p>
        En caso de considerarlo necesario, le informamos que tiene derecho de
        acudir ante la autoridad de control competente para hacer valer
        cualquier inconformidad relacionada con el tratamiento legítimo de sus
        datos personales.
      </p>
      <br />
      <h3 class="font-bold text-base">
        Medio para comunicar cambios al Aviso de Privacidad:
      </h3>
      <p>
        Mabe se reserva el derecho, bajo su exclusiva discreción, de cambiar,
        modificar, agregar, eliminar y/o actualizar partes del presente Aviso de
        Privacidad en cualquier momento. En tal caso, Mabe le informará de los
        cambios a través de una publicación en el apartado de “Privacidad” de su
        sitio web o mediante el uso de los datos de contacto que usted nos ha
        proporcionado (correo electrónico, número de celular o número telefónico
        de casa)
      </p>
      <br />
      <h3 class="font-bold text-base">Fecha de última actualización:</h3>
      <p>
        El presente Aviso de Privacidad corresponde a la versión de noviembre de
        2024
      </p>
      <br />
      <h3 class="font-bold text-base">ACEPTACIÓN DEL AVISO DE PRIVACIDAD.</h3>
      <p>
        Al registrarse como usuario de nuestro Sitio Web y/o realizar
        actividades de adquisición de bienes, productos y/o servicios usted
        reconoce que Mabe ha puesto a su disposición el presente Aviso de
        Privacidad y que por lo tanto, ha sido debidamente informado sobre las
        condiciones generales a las que se sujetará el tratamiento de sus datos
        personales y acepta que Mabe dé tratamiento y en su caso transfiera, sus
        datos de acuerdo con lo informado en este Aviso de Privacidad.
      </p>
    </div>
  </div>
</dialog>

<!-- Modal -->
<dialog id="terms" class="modal w-full p-0 bg-black bg-opacity-50">
  <div class="fixed inset-0 bg-black bg-opacity-50"></div>

  <div
    id="modalBox_terms"
    class="modal-box p-10 bg-white relative z-10 rounded-xl text-[#1E3746]"
  >
    <form method="dialog">
      <button
        class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 text-secondary font-bold text-2xl"
      >
        ✕
      </button>
    </form>
    <h3 class="text-lg font-bold text-primary">TÉRMINOS Y CONDICIONES</h3>

    <span [innerHTML]="frontSettings.TERMS_AND_CONDITIONS?.html" class="py-4">
    </span>
  </div>
</dialog>
